<script setup>
  import { ref, onMounted } from 'vue'

  const myVideo = ref(null);
  onMounted(() => {
    if(myVideo && myVideo.value) {
      myVideo.value.addEventListener("canplay", function () {
        setTimeout(function () {
          myVideo.value.pause();
        }, 2000);
        setTimeout(function () {
          myVideo.value.play();
        }, 5000);
      });
    }
  });
</script>
<template>
    <div class="contact-header">
        <span class="typewriter">
          {{ $t('field.contact_title') }}
        </span>
        <div class="video-wrapper">
          <div class="contact-header-desktop">
            <video 
              ref="myVideo"
              class="video-js"
              id="myVideo"
              height="375"
              preload="auto"
              autoplay muted loop>
              <source src="/assets/videos/Capcalera_WEB_Charger_BO.mp4" type="video/mp4">
            </video>
          </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
    .contact-header {
        height: 425px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 90px;
        letter-spacing: -4.5px;
        font-family: 'CircularStd-Black';
        .typewriter {
            animation: typing 2s steps(22), blink .5s step-end infinite alternate;
            white-space: nowrap;
            overflow: hidden;
            border-right: 3px solid;
            letter-spacing: -4.5px;
            width: 100%;
            text-align: center;
            animation: typing 2s steps(22), blink .5s step-end infinite alternate;
            white-space: nowrap;
            overflow: hidden;
            border-right: 3px solid transparent;
        }
    }
    @keyframes typing {
        from {
          width: 0
        }
      }
          
      @keyframes blink {
        50% {
          border-color: transparent
        }
      }
      .video-wrapper {
        padding-top: 60px;
        height: 375px;
        video {
            object-fit: fill;
            width: 100%;
            height: 100%;
            height: 375px;
            object-fit: cover;
            object-position: center;
            position: absolute;
            left: 0;
            right: 0;
            top: 55px;
            bottom: 0;
            z-index: -1;
        }
      }

  @media (max-width: 1000px) {
    .contact-header {
      background-image: url("/assets/mobile/Contacto_movile.webp");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      font-size: 45px;
      letter-spacing: -3px;
      .typewriter {
        white-space: wrap;
        overflow: auto;
        font-size: 55px;
        animation: unset;
        letter-spacing: -1.1px;
      }
    }
    .video-wrapper {
      display: none;
    }
  }
  @media (max-width: 600px) {
    .contact-header {
      height: 210px;
      .typewriter {
        font-size: 45px;
        line-height: 47px;
      }
    }
    .video-wrapper {
      display: none;
    }
    .contact-body-wrapper .contact-body-container .contact-body-container-wrapper .contact-form-block  {
      padding-bottom: 10px;
    }
  }
</style>